// i18next-extract-mark-ns-start LaRubrique
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { colors, tabletThresholdPixels } from '../../home/v4/styledComponents';

const Highlight = styled.div`
  font-family: Libre Baskerville;
  font-style: normal;
  font-weight: normal;
  font-size: 40px;
  line-height: 53px;
  color: ${colors.black};

  @media (max-width: ${tabletThresholdPixels}) {
    font-size: 30px;
    line-height: 40px;
  }
`;

const Italic = styled.span`
  font-style: italic;
  color: ${colors.grey200};
`;

function BlockHighlight({ highlight }) {
  const { t } = useTranslation();
  return (
    <Highlight>
      {highlight
        .split('<i>')
        .map((part, index) => index % 2 === 0
          ? (<span key={part}>{t(part)}</span>)
          : (<Italic key={part}>{t(part)}</Italic>))}
    </Highlight>
  );
}

BlockHighlight.propTypes = {
  highlight: PropTypes.string.isRequired,
};

export default BlockHighlight;
